
import VocherMainComp from "../../components/vocher/VocherMainComp"

export const DigitalVocherPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <VocherMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}